/**
 * 业务相关的工具方法
 * （不具普适性）
 */

// 过滤掉一部分低错类型
export const filterLowErrorType = (list) => {
  return list
    ?.map((item) => {
      // const errNos = [1001, 1002, 1401, 1402, 2101];
      // item.errNos = item?.errNos?.filter((errNo) => {
      //   return !errNos.includes(errNo);
      // });
      // const errMsgs = [
      //   '标点符号全半角不符合规范',
      //   '标点空格错误使用有误',
      //   '标点错误:英文符号后面需要空格',
      //   '数值与单位之间应保留一个空格',
      // ];
      // item.errMsgs = item?.errMsgs?.filter((errMsg) => {
      //   return !errMsgs.includes(errMsg);
      // });
      return item;
    })
    ?.filter((item) => {
      return !(!item?.errMsgs?.length && item?.errorType == 'low_error');
    });
};

// 低错格式转换，后台返回的errorList => 富文本编辑器可用的 errors
export const rebuildEditorErrors = (list) => {
  return (
    list?.map((item) => ({
      errorType: item.errorType ?? 'low_error',
      position: [item.errorSPos, item.errorEPos],
      payload: item.errorType === 'spell_error' ? item.suggests : item.errMsgs,
    })) ?? []
  );
};
